/* eslint  @typescript-eslint/ban-ts-comment: 0 */ // --> OFF
import "jQuery"; // eslint-disable-line
import "JSZip"; // eslint-disable-line
import "./kendo-ui-license.js";
import "@progress/kendo-ui";
import "intl-tel-input/build/css/intlTelInput.css";
import * as FilterTemplates from "../../Views/Shared/Grid/FilterTemplates";
import "./GlobalScripts/fileDownload";
//Widgets
import { MultiSelectPopup } from "../../Views/Shared/MultiSelectPopup";
import { YearlessDatePicker } from "../../Widgets/DatePicker/YearlessDatePicker";
import { DropDownMenu } from "../../Widgets/DropDownMenu/DropDownMenu";
import { OrphyEditor } from "../../Widgets/Editor/OrphyEditor";
import { MultiSelectWithAutoTransform } from "../../Widgets/MultiSelect/MultiSelectWithAutoTransform";
import { MultiSelectWithInsert } from "../../Widgets/MultiSelect/MultiSelectWithInsert";
//Global Scripts
import ButtonFunctions from "./GlobalScripts/ButtonFunctions";
import TelerikHelpers from "./GlobalScripts/TelerikHelpers";
import CommonFunctions from "./GlobalScripts/CommonFunctions";
import ValidationHelper from "./GlobalScripts/ValidationHelper";
import DropDownPlus from "./GlobalScripts/DropDownPlus";
import ContentDisposition from "./GlobalScripts/ContentDisposition";
import EditorToolFunctions from "./GlobalScripts/EditorToolFunctions";
import KendoTemplateLoader from "./GlobalScripts/KendoTemplateLoader";
const global = window; // eslint-disable-line @typescript-eslint/no-explicit-any
global.FilterTemplates = FilterTemplates; //may move to grid
global.MultiSelectPopup = MultiSelectPopup;
global.YearlessDatePicker = YearlessDatePicker;
global.DropDownMenu = DropDownMenu;
global.OrphyEditor = OrphyEditor;
global.MultiSelectWithAutoTransform = MultiSelectWithAutoTransform;
global.MultiSelectWithInsert = MultiSelectWithInsert;
global.ButtonFunctions = ButtonFunctions;
global.TelerikHelpers = TelerikHelpers;
global.CommonFunctions = CommonFunctions;
global.ValidationHelper = ValidationHelper;
global.DropDownPlus = DropDownPlus;
global.ContentDisposition = ContentDisposition;
global.EditorToolFunctions = EditorToolFunctions;
global.KendoTemplateLoader = new KendoTemplateLoader();
//Widget Binders
global.kendo.data.binders.widget.multiselectwithautotransform = kendo.data.binders.widget.multiselect;
global.kendo.data.binders.widget.multiselectwithinsert = kendo.data.binders.widget.multiselect;
global.kendo.data.binders.strictInvisible = kendo.data.Binder.extend({
    refresh() {
        if (this.bindings.strictInvisible.get() === false) {
            this.element.style.display = "";
        }
        else {
            this.element.style.display = "none";
        }
    }
});
global.kendo.data.binders.visibleIfNot = kendo.data.Binder.extend({
    refresh() {
        const value = this.bindings.visibleIfNot.get();
        const notAllowedValue = this.element.getAttribute("data-visibleifnot");
        // eslint-disable-next-line eqeqeq
        if (value != notAllowedValue) {
            $(this.element).show();
        }
        else {
            $(this.element).hide();
        }
    }
});
//kendo overrides
global.kendo.getWidgetFocusableElement_original = global.kendo.getWidgetFocusableElement;
global.kendo.getWidgetFocusableElement = (element) => {
    const instance = global.kendo.widgetInstance(element);
    if (instance && instance.options && instance.options.name && instance.options.name === "OrphyEditor") {
        return $(instance.body);
    }
    return global.kendo.getWidgetFocusableElement_original(element);
};
//kendo bug fix should be fixed in 2025 => https://github.com/telerik/kendo-ui-core/issues/8104
// eslint-disable-next-line no-underscore-dangle
if (!global.kendo.ui.Menu.prototype._removeHoverItem) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    global.kendo.ui.Menu.prototype._removeHoverItem = function () { }; // eslint-disable-line
}
